import { DeleteOutlined, EditOutlined, RollbackOutlined } from "@ant-design/icons";
import React from "react";
import { t } from "i18next";
import { message } from "antd";
import {
    assignToMe,
    postWorkflowProcessEngine, recallProcessApi,
    rollbackProcessApi
} from "../../../../../../api/workplace/process/work-process/process-config";
import { ModalMethodCustom } from "./modal/ModalMethodCustom";
import { AbilityUtil } from "../../../../../../custom/permission/Can";
import { ActionKeys, SubjectName } from "../../../../../../custom/permission/Ability";
import { handleOnDelete } from "./deleteShiftWork";
import { onReloadData } from "../../../../../../redux/actions/layout/interaction/action";
import { store } from "../../../../../../redux/store/store";
import { APP_CODE, APP_CODE_SALARY } from "./Constant";

export const getActionButtons = (data, id,
    status,
    classPk,
    moduleCode,
    appCode,
    hiddenRecall,
    decisionNo,
    creatorId,
    onAfterSuccess = {
        delete: () => { },
        recall: () => { }
    }) => {

    const condition = {
        status,
        hiddenRecall,
        creatorId
    }

    function setRedirect(data) {
        if (data?.shiftConfigId && data?.shiftConfigId !== 0) {
            return "/hrm/timekeeping/wage/template/update/" + data.shiftConfigId
        } else {
            return "/hrm/timekeeping/wage/table/manual-add/" + data?.id
        }
    }

    return [
        AbilityUtil.allow(ActionKeys.UPDATE, appCode === APP_CODE ? SubjectName.timeKeeping : SubjectName.salaryTable, condition) ? {
            key: "update",
            name: t("common.update"),
            icon: <EditOutlined className={"text-lg text-[#344054]"} />,
            redirect: appCode === APP_CODE ? `/hrm/timekeeping/time-sheet/shift-assignment/update/${classPk}` : setRedirect(data)
        } : null,
        AbilityUtil.allow(ActionKeys.DELETE, appCode === APP_CODE ? SubjectName.timeKeeping : SubjectName.salaryTable, condition) ? {
            key: "delete",
            name: t("common.delete"),
            icon: <DeleteOutlined />,
            onClick: () => handleOnDelete(id, classPk, moduleCode, appCode, onAfterSuccess?.delete, decisionNo)
                .then((response) => {
                }).catch(() => {
                })
        } : null,
        AbilityUtil.allow(ActionKeys.RECALL, appCode === APP_CODE ? SubjectName.timeKeeping : SubjectName.salaryTable, condition) ? {
            key: "recall",
            name: t("common.recall"),
            icon: <RollbackOutlined />,
            onClick: () => {
                ModalMethodCustom.confirm({
                    content: <div
                        dangerouslySetInnerHTML={{
                            __html: t("common.recallConfirm",
                                { module : `<b>${decisionNo}</b>` ,
                                 name : appCode === APP_CODE ? t("common.shift") : t("common.payroll") }),
                        }}
                    />,

                    onOk: () => {
                        return recallProcessApi({ classPk, moduleCode, appCode }).then(r => {
                            onAfterSuccess?.recall && onAfterSuccess.recall()
                            message.success(t("common.recallMessage")).then(r => { })
                            // store.dispatch(onReloadData(true))
                        }).catch(() => {
                        })
                    },
                    cancelText: t("common.no"),
                    okText: t("common.recall")
                })
            }
        } : null,
    ]?.filter(item => !!item)
}

export const onClickTransitionButton = ({
    classPk,
    moduleCode,
    appCode,
    code,
    name,
    onAfterSuccess,
    decisionNo
}) => {
    ModalMethodCustom.confirm({
        title: t("common.title_confirm") + name,
        content:   <div
            dangerouslySetInnerHTML={{
                __html: t("common.confirm_action",
                    { action : `<b>${name}</b>` ,
                        module : (appCode === APP_CODE ? t("common.shift") : t("common.payroll")) + ` <b>${decisionNo}</b>`  }),
            }}
        />,
            // <div>Bạn có chắc chắn là muốn {name} {appCode === APP_CODE ? "phân ca" : "bảng lương"} <span
            // className={"font-bold"}>{decisionNo}</span> không?</div>,

        onOk: () => {
            return postWorkflowProcessEngine({
                transitionCode: code,
                moduleCode,
                appCode,
                classPk
            }).then(() => {
                onAfterSuccess && onAfterSuccess()
                message.success(`${name} ${t("common.success")}`).then(r => { })
                store.dispatch(onReloadData(true))
            }).catch(() => {
            })
        },
        cancelText: t("common.no"),
        okText: name
    })
}

export const onClickRequestButton = ({
    classPk,
    moduleCode,
    appCode,
    name,
    approval,
    type,
    onAfterSuccess,
    decisionNo
}) => {
    (ModalMethodCustom.confirm({
        title: t("common.title_confirm") + name,
        content:
            <div
                dangerouslySetInnerHTML={{
                    __html: t("common.confirm_action",
                        { action : `<b>${name}</b>` ,
                            module :  (appCode === APP_CODE ? t("common.shift") : t("common.payroll")) + ` <b>${decisionNo}</b>`  }),
                }}
            />,

            // <div>Bạn có chắc chắn là muốn {name} {appCode === APP_CODE ? "phân ca" : "bảng lương"} <span
            // className={"font-bold"}>{decisionNo}</span> không?</div>,
        onOk: () => {
            rollbackProcessApi({
                appCode,
                moduleCode,
                classPk,
                approval,
                type,
            }).then(() => {
                onAfterSuccess && onAfterSuccess()
                message.success(`${t("common.youHave")} ` + name).then(r => { })
                store.dispatch(onReloadData(true))
            }).catch(() => {
            })
        },
        cancelText: t("common.no"),
        okText: name
    }))
}

export const onClickAssignButton = ({
    classPk,
    moduleCode,
    appCode,
    onAfterSuccess
}) => {

    return assignToMe({
        appCode,
        moduleCode,
        classPk,
    }).then(() => {
        onAfterSuccess && onAfterSuccess()
        message.success(t("applicationActionBar.message.assignSuccess"))
    }).catch(() => {
    })
}